angular.module('document')
    .component('documentFilesCount', {
        bindings: {
            document: '<'
        },
        controller: function ($element) {
            this.$onChanges = () => {
                const hasFiles = this.document != null && this.document.filesCount > 0;
                $element.css('display', hasFiles ? '' : 'none');
            };
        },
        template: `
            <span class="document-info-header" title="Plików: {{$ctrl.document.filesCount}}">
                <i class="fa fa-fw fa-paperclip"></i>{{$ctrl.document.filesCount}}
            </span>
        `
    })
